<template>
    <v-card-actions component="CharacterCreateForm" :class="{ creating: isOpen }">
        <div class="header" :class="{ hide: isOpen }">
            <div>Characters</div>
            <btn
                size="small"
                color="accent"
                :icon="'add_circle'"
                :text="'ADD NEW'"
                v-if="canEditProject"
                :class="{ creating: isOpen }"
                @click="open"
            />
        </div>

        <div class="form" :class="{ show: isOpen }">
            <v-form ref="form" v-model="valid" @submit.prevent="addCharacter">
                <v-text-field
                    ref="input"
                    class="input"
                    dense
                    hide-details="true"
                    placeholder="Character name"
                    :rules="requiredRule"
                    @keyup.enter="addCharacter"
                    @keyup.esc="isOpen = false"
                    v-model="character.meno"
                />
                <btn :icon="'close'" color="ghost" size="icon" @click.prevent="isOpen = false" />
                <btn :icon="'check'" color="base" size="icon" />
            </v-form>
        </div>
    </v-card-actions>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import draggable from 'vuedraggable';
import Mp3Player from '@/components/.global/Mp3Player.vue';
import CharacterListItem from '@/components/Project/Character/CharacterListItem.vue';

import { defaultCharacter } from '@/store/Admin/CharacterStore';

export default {
    name: 'CharacterList',

    data() {
        return {
            fatalError: false,
            isOpen: false,
            showInput: false,
            valid: true,
            requiredRule: [(v) => !!v || 'This field is required'],
            character: {},
            immediate: true,
            actors: [],
            dragOptions: {
                ghostClass: 'ghost',
            },
        };
    },

    created() {
        this.character = { ...defaultCharacter };
    },

    methods: {
        ...mapActions(['storeCharacter']),

        addCharacter() {
            this.$refs.form.validate();

            if (!this.valid) {
                return;
            }

            this.character.id_projekt = this.project.id;
            this.storeCharacter(this.character);

            this.reset();
        },

        open() {
            this.isOpen = true;
            setTimeout(() => {
                this.$refs.input.focus();
            }, 300);
        },

        reset() {
            this.character = { ...defaultCharacter };
            this.isOpen = false;
        },
    },

    computed: {
        ...mapGetters({
            project: 'getProject',
            canEditProject: 'canEditProject',
        }),
    },

    components: {
        draggable,
        Mp3Player,
        CharacterListItem,
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='CharacterCreateForm'] {
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 33px;
    padding: 0 !important;

    .header,
    .form {
        .flex-row;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transition: 0.3s;
    }

    .header {
        &.hide {
            transform: translateX(-100%);
        }
    }

    .form {
        transform: translateX(100%);

        form {
            width: 100%;
        }

        .input {
            margin-right: 10px;
        }

        button {
            margin-left: 3px;
        }

        &.show {
            transform: translateX(0%);
        }
    }

    .v-input {
        padding: 0;
        margin: 0;
    }

    .col {
        padding: 0;

        .v-btn {
            height: auto;
            padding: 0 8px;
        }
    }

    .warning {
        background: @warning;
    }

    .creating {
        & > .v-btn {
            left: -100%;
        }

        & > .row {
            left: 0%;
        }
    }

    .row {
        margin-left: 0;
        margin-right: 0;
    }
}
</style>
